
var RaphaelView = require('raphaelItemView'),
    DeleteBtn = require('./deleteBtn'),
    _ = require('underscore');


/**
 * Multiview set of button sets
 * Could use model like this as proto for others -- easier shape/r_view management
 * This really needs cleaning up ...
 */

module.exports = RaphaelView.extend({

    PADDING: {
        x: 10,
        y: 0
    },

    initialize: function() {

        /* These instance variables were very incorrectly on the prototype -- define here */
        this.btnSet = null;
        this.btnViewRef = {}; // button key labels by Raphael Views they represent (eg delete X raphael view)
        this.oBox = null; // the original bounding box of the view
        this.isFlippedHorizontally = false;

        /* -- old init --*/
        var self = this;
        var pShape = this.options.parent;
        this.btnSet = pShape.paper.set(); // TODO: only if it has them


        // TODO: subclass or pass in option to create delete button by default
        if ( !pShape.shapeModel.isFindAndRedactShape) {

            this.addBtn('delete', DeleteBtn);

        } else {

            // TEMP ...
            //this._setOBox();

            this.oBox = {
                height: 0,
                width: 0,
                x: 0,
                y: 0,
                x2: 0,
                y2: 0
            };

        }


        /* adjustment for print in the center vertical -- still with vert ?*/
        this.cy = this.oBox.height / 2;

        /* TODO: poly specific subset -- lines as well */
        this.listenTo(pShape, 'shape.move shape.onAfterBaseScale shape.resizeRect', this.move);
        this.listenTo(pShape, 'shape.redaction.poly.resize', this.fadeOut);
        this.listenTo(pShape, 'shape.resizePolyEnd', function() {
            var args = _.toArray(arguments);
            self.move.apply(self, args.concat(1));
        });

        this.setElement(this.btnSet);
        return this;

    },

    fadeOut: function() {
        this.getIconSet().fadeOut();
    },


    /* adds to hash of BB R views (for destruction -- and also adds to the btn set (for collection R el actions */
    // TODO: clean and make more generic -- now only assumes spec settings
    // Note: also create first button set and the obox -- should separate ...
    addBtn: function(btnLbl, ViewConstructor, onNewColumn) { 

        var pBox = this.options.parent.el.getBBox();
        var PAD = 5;

        var v = new ViewConstructor( _.extend(this.options, {
            x: !onNewColumn //always delete btn
                ? pBox.x2 + this.PADDING.x      //(!this.oBox ? 0 : this.oBox.width),
                : this.oBox.x2 + this.PADDING.x,
            y: !onNewColumn 
                ? pBox.y + this.PADDING.y  + (!this.oBox ? 0 : this.oBox.height + PAD)
                : pBox.y
        } )).render();

        this.btnViewRef[btnLbl] = v;
        this.btnSet.push(v.el);
        this._setOBox();

        return this;
    },
    getView: function(btnLabel) {
        return this.btnViewRef[btnLabel];
    },
    // ( must call after shape rendered  )
    _setOBox: function() {
        this.oBox = this.btnSet.getBBox();
    },


    /**
     * TODO: diff subtype for poly -- move goes to the outermost points
     * Could only pass from triggerer on move --resize is moving diff ways -- getting rel to the shape is the key
     * by default bbox of pshape , includes transform    --shape.move -- b, dx, dy, scale is diff -- so store here
     * Check if in bounds (only right and top); only considering top left default
     */

    move: function(box, fadeIn) {

        this.isFlippedHorizontally = false;

        var dx = box.x2 - this.oBox.x + this.PADDING.x,
            dy = box.y - (this.oBox.y + this.cy) + this.PADDING.y,// + this.topOffset, //not taking into account relation from op
            paperBounds = this.options.channel.request('canvasContainerRel'), // TODO: -- cache
            sx = 1, // currently only scaling one way
            sy = 1;

        // if over right
        if (this.oBox.x2 + dx >= paperBounds.x2) {
            dx -= box.width + this.oBox.width + (this.PADDING.x * 2);
            this.isFlippedHorizontally = true;
        }
        // if over top, can (no else; can be both)
        if (this.oBox.y + dy <= paperBounds.y) {
            dy += box.height; //note: want relative to the parent shape
        }

        // DVBC-1425 - handle over bottom also -- would only occur for shapes with really small height
        if ( this.oBox.y2 + dy >= paperBounds.y2) {
            dy -= this.oBox.height;
        }

        this.btnSet.transform('S' + sx + ',' + sy + 'T' + dx + ',' + dy);

        fadeIn && this.getIconSet().fadeIn(); //for end move of poly redact -- hidden on start

        this.options.parent.trigger('shape.buttonSet.postMove');

    },

    /* return just the icons from the set -- now an array */
    getIconSet: function() {

      return this.btnSet.paper.set( _.map(this.btnViewRef, function(v) {
           return v.getIcon();
       }));

    },


    onBeforeDestroy: function() {

        _.invoke(  _.values(this.btnViewRef), 'destroy' );

        this.remove(); //(BB View)

        // can't call from here (RECURSION)
        // this.options.parent.shapeModel.trigger('destroy'); //(quick fix to destroy top up if not called -- eg on save when dialog close)
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/selectSet/btn/buttonSet.js
 ** module id = 207
 ** module chunks = 0
 **/